import { styled } from "styled-components";
import Button from "../Button";

const GroupWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: -4px 1px 13px -9px var(--d8s-shadow);

    ${Button} {
        border-radius: 0;
        box-shadow: none;
    }

    ${Button}:first-child {
        border-radius: 5px 0 0 5px;
    }

    ${Button}:last-child {
        border-radius: 0 5px 5px 0;
    }
`;


const ButtonGroup = ({ children }) => {
	return (
		<GroupWrapper>
			{children}
		</GroupWrapper>
	)
} ;

export default ButtonGroup;
